(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-tabs"] && !Shopify.designMode) return;
  try {
    
class TabsAccordionManager {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('[data-tab]');
    this.contents = container.querySelectorAll('.tab-content');
    this.accordionHeaders = container.querySelectorAll('.accordion-header');
    this.faqQuestions = container.querySelectorAll('.faq-question');
    
    this.isAnimating = false;
    
    this.init();
    this.handleResize();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
    this.accordionHeaders.forEach(header => {
      header.addEventListener('click', () => this.toggleAccordion(header));
    });
    this.faqQuestions.forEach(question => {
      question.addEventListener('click', () => this.toggleFAQ(question));
    });
    window.addEventListener('resize', () => this.handleResize());

    // Initialize all accordion contents with proper initial state
    this.container.querySelectorAll('[id^="accordion-"]').forEach(content => {
      if (!content.closest('.accordion-header')?.classList.contains('active')) {
        content.style.maxHeight = '0px';
        content.style.overflow = 'hidden';
        content.style.display = 'none';
      }
    });
  }

  handleResize() {
    const isMobile = window.innerWidth <= 991;
    if (isMobile) {
      this.contents.forEach(content => {
        content.style.display = 'none';
        content.style.maxHeight = '0px';
      });
    } else {
      // Reset accordion states
      this.accordionHeaders.forEach(header => {
        header.classList.remove('active');
        const content = this.container.querySelector(`#accordion-${header.dataset.accordion}`);
        if (content) {
          content.style.display = 'none';
          content.style.maxHeight = '0px';
        }
      });
      // Show active tab content
      const activeTab = this.container.querySelector('.tab-button.active');
      if (activeTab) {
        const targetId = activeTab.dataset.tab;
        const activeContent = this.container.querySelector(`#${targetId}`);
        if (activeContent) { // Added check if activeContent exists
          activeContent.style.display = 'block';
          activeContent.style.maxHeight = 'none';
        }
      }
    }
  }

  switchTab(selectedTab) {
    const targetId = selectedTab.dataset.tab;
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    selectedTab.classList.add('active');
    selectedTab.setAttribute('aria-selected', 'true');
    
    this.contents.forEach(content => {
      content.classList.remove('active');
      content.style.display = 'none';
      content.style.maxHeight = '0px';
    });
    
    const activeContent = this.container.querySelector(`#${targetId}`);
    activeContent.classList.add('active');
    activeContent.style.display = 'block';
    activeContent.style.maxHeight = 'none';
  }

  async toggleAccordion(header) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const content = this.container.querySelector(`#accordion-${header.dataset.accordion}`);
    if (!content) {
      this.isAnimating = false;
      return;
    }

    const isOpen = header.classList.contains('active');
    
    // Close other accordions
    for (const h of this.accordionHeaders) {
      if (h !== header && h.classList.contains('active')) {
        const otherContent = this.container.querySelector(`#accordion-${h.dataset.accordion}`);
        if (otherContent) {
          await this.animateAccordion(h, otherContent, false);
        }
      }
    }

    // Toggle clicked accordion
    await this.animateAccordion(header, content, !isOpen);
    this.isAnimating = false;
  }

  async animateAccordion(header, content, open) {
    return new Promise(resolve => {
      if (open) {
        // Opening animation
        content.style.display = 'block';
        content.style.overflow = 'hidden';
        
        // Reset max-height to 0 first
        content.style.maxHeight = '0px';
        
        // Force reflow
        content.offsetHeight;
        
        // Set up transition
        content.style.transition = 'max-height 0.3s ease-out';
        
        content.style.maxHeight = `${content.scrollHeight + 100}px`;
        
        header.classList.add('active');
        
        const onTransitionEnd = () => {
          content.style.maxHeight = 'none';
          content.style.overflow = 'visible';
          content.removeEventListener('transitionend', onTransitionEnd);
          resolve();
        };
        
        content.addEventListener('transitionend', onTransitionEnd);
      } else {
        // Closing animation
        content.style.overflow = 'hidden';
        
        content.style.maxHeight = `${content.scrollHeight}px`;
        
        content.offsetHeight;
        
        content.style.transition = 'max-height 0.3s ease-out';
        content.style.maxHeight = '0px';
        
        header.classList.remove('active');
        
        const onTransitionEnd = () => {
          content.style.display = 'none';
          content.removeEventListener('transitionend', onTransitionEnd);
          resolve();
        };
        
        content.addEventListener('transitionend', onTransitionEnd);
      }
    });
  }

  toggleFAQ(question) {
    const answer = question.querySelector('.faq-answer');
    const isOpen = question.classList.contains('active');
    
    this.faqQuestions.forEach(q => {
      if (q !== question) {
        q.classList.remove('active');
        const otherAnswer = q.querySelector('.faq-answer');
        otherAnswer.style.display = 'none';
        otherAnswer.style.maxHeight = '0px';
      }
    });
    
    question.classList.toggle('active');
    if (isOpen) {
      answer.style.display = 'none';
      answer.style.maxHeight = '0px';
    } else {
      answer.style.display = 'block';
      answer.style.maxHeight = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const tabsContainers = document.querySelectorAll('[data-tabs]');
  tabsContainers.forEach(container => new TabsAccordionManager(container));
  
  // --- FIX: Auto-select first available tab ---
  const firstTabButton = document.querySelector('.tabs-navigation .tab-button');
  if (firstTabButton) {
    firstTabButton.classList.add('active');
    firstTabButton.setAttribute('aria-selected', 'true');
    const firstTabContent = document.querySelector(`#${firstTabButton.dataset.tab}`);
    if (firstTabContent) {
      firstTabContent.classList.add('active');
    }
  }
  const firstAccordion = document.querySelector('.mobile-accordion .accordion-header');
  if (firstAccordion) {
    // Optional: Auto-open first accordion on mobile
    // firstAccordion.classList.add('active');
    // const firstAccordionContent = document.querySelector(`#accordion-${firstAccordion.dataset.accordion}`);
    // if (firstAccordionContent) {
    //   firstAccordionContent.style.display = 'block';
    //   firstAccordionContent.style.maxHeight = 'none';
    // }
  }
});

  } catch(e) { console.error(e); }
})();
})();
